import { Building2, Home as HomeIcon } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { ServiceRow } from "@/components/services/ServiceRow";
import { Partners } from "@/components/home/Partners";
import { CtaBand } from "@/components/CtaBand";
import { BUSINESS_SERVICES, RESIDENTIAL_SERVICES } from "@/data/siteData";

const Group = ({ id, Icon, eyebrow, title, description, items, startIndex, tinted }) => (
  <section id={id} data-testid={`services-group-${id}`} className={tinted ? "bg-secondary/60 py-24 lg:py-32" : "py-24 lg:py-32"}>
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="flex items-start gap-5">
        <span className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary text-white sm:flex">
          <Icon className="h-5 w-5" strokeWidth={1.5} />
        </span>
        <SectionHeading eyebrow={eyebrow} title={title} description={description} />
      </Reveal>
      <div className="mt-20 space-y-24">
        {items.map((s, i) => <ServiceRow key={s.slug} service={s} index={startIndex + i} flip={i % 2 === 1} />)}
      </div>
    </div>
  </section>
);

export default function Services() {
  return (
    <main data-testid="services-page">
      <section className="border-b border-border bg-secondary/40">
        <div className="mx-auto max-w-7xl px-6 pb-20 pt-24 lg:px-10 lg:pb-28 lg:pt-32">
          <Reveal>
            <p className="eyebrow text-primary">Our Vision &amp; Services</p>
            <h1 className="mt-6 max-w-3xl font-display text-4xl font-light leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-6xl">
              Specialized operations &amp; maintenance for every stage of a solar system&rsquo;s life.
            </h1>
            <div className="mt-10 flex flex-wrap gap-3">
              <a href="#business" data-testid="services-jump-business" className="rounded-full border border-primary/30 px-5 py-2.5 text-sm text-primary transition-colors hover:bg-primary hover:text-white">Business Consulting</a>
              <a href="#residential" data-testid="services-jump-residential" className="rounded-full border border-primary/30 px-5 py-2.5 text-sm text-primary transition-colors hover:bg-primary hover:text-white">Residential Homeowner</a>
            </div>
          </Reveal>
        </div>
      </section>

      <Group
        id="business"
        Icon={Building2}
        eyebrow="Business Consulting Services"
        title="Capacity, training and quality control for solar enterprises."
        description="Purpose-built support for installers, EPCs, manufacturers and asset owners who need certified field expertise without adding headcount."
        items={BUSINESS_SERVICES}
        startIndex={1}
      />
      <Group
        id="residential"
        Icon={HomeIcon}
        eyebrow="Residential Homeowner Services"
        title="Keep your investment producing for decades."
        description="Straightforward repair, re-roof coordination and expansion services for homeowners — including systems whose original installer is no longer in business."
        items={RESIDENTIAL_SERVICES}
        startIndex={4}
        tinted
      />
      <Partners />
      <CtaBand />
    </main>
  );
}
